module.exports = __webpack_public_path__ + "static/stardust-card-expandable-e9ee5e96966e1cc86923c53de919e782.gif";